import type { ClientProfile } from "@kkp/api-client";
import { z } from "zod";
import { apiRequest } from "./client";

import { parseObject } from "./parse";

/**
 * Boundary schema for the client profile. `perTransactionFeeIdr` is a MoneyIdr
 * *string* on the wire and stays a string end-to-end (parsed only at the display
 * formatter). Non-strict on purpose so extra server-only fields are tolerated.
 */
export const ClientProfileSchema = z.object({
  companyId: z.string(),
  companyName: z.string(),
  vaNumber: z.string(),
  vaName: z.string(),
  vaState: z.enum(["disabled", "open", "paid", "error", "unregistered"]),
  vaAmountIdr: z.string().regex(/^\d+$/).nullable(),
  vaExpiresAt: z.iso.datetime({ offset: true }).nullable(),
  companyNpwp: z.string(),
  picFullName: z.string(),
  picEmail: z.string(),
  picPhone: z.string(),
  perTransactionFeeIdr: z.string(),
  currentIp: z.string(),
  currentCity: z.string(),
  currentRegion: z.string(),
  currentCountry: z.string(),
  currentUserAgent: z.string(),
  actorEmail: z.string(),
}) satisfies z.ZodType<ClientProfile>;

export type { ClientProfile };

export async function getProfile() {
  const data = await apiRequest<unknown>({
    path: "/profile",
    method: "GET",
  });
  return parseObject(ClientProfileSchema, data, "client profile");
}
